"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoreType = exports.coreTypes = void 0;
/*
 * If this set ever increases beyond default|group, be sure to update the logic
 * for `MutationCreatePage` since copying currently expects only these two types.
 */
exports.coreTypes = {
    default: 'default',
    group: 'group',
};
/**
 * Checks if the given `value` is a valid `CoreType`
 */
function isCoreType(value) {
    return typeof value === 'string' && value in exports.coreTypes;
}
exports.isCoreType = isCoreType;
